module.exports = __webpack_public_path__ + "dbb476d2e0d24d2b18dd8692b0a8985d.png";